import { render, staticRenderFns } from "./freebie-offer.vue?vue&type=template&id=bf850722&scoped=true&"
import script from "./freebie-offer.vue?vue&type=script&lang=js&"
export * from "./freebie-offer.vue?vue&type=script&lang=js&"
import style0 from "./freebie-offer.vue?vue&type=style&index=0&id=bf850722&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf850722",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
